import { useEffect, useState } from "react";
import { MessageSquare } from "lucide-react";
import api from "@/lib/api";

export default function AdminSupport() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/support").then((r) => setItems(r.data)); }, []);

  return (
    <div className="px-5 lg:px-10 py-8 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Support requests</h1>
      <div className="mt-5 space-y-3">
        {items.length === 0 ? (
          <div className="text-center py-12 text-brand-muted bg-white rounded-2xl border border-brand-borderc"><MessageSquare className="w-10 h-10 mx-auto text-brand-purple" /><div className="mt-2">No requests yet</div></div>
        ) : items.map((s) => (
          <div key={s.id} className="bg-white rounded-2xl border border-brand-borderc p-5">
            <div className="flex justify-between flex-wrap gap-2">
              <div>
                <h3 className="font-semibold text-brand-navy">{s.subject}</h3>
                <div className="text-xs text-brand-muted">{s.name} · {s.email} · {new Date(s.created_at).toLocaleString()}</div>
              </div>
              <span className={`text-xs px-2 py-1 rounded-full ${s.status === "open" ? "bg-amber-50 text-amber-700" : "bg-emerald-50 text-emerald-700"}`}>{s.status}</span>
            </div>
            <p className="text-sm text-brand-text mt-3 whitespace-pre-wrap">{s.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
